/* @flow */

/* eslint-disable camelcase */
import * as React from 'react';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import Moment from 'react-moment';
// TODO: No def for this.
// $FlowFixMe
import debounce from 'lodash.debounce';

import { deleteOrder as deleteOrderAction } from '../actions/actionsSet/order';

import FlexBox from './FlexBox';
import Dropdown from './Dropdown';
import EmptyResult from './EmptyResult';
import ScrollableTable from './ScrollableTable';
import SelfOtherPairsToggler from './SelfOtherPairsToggler';
import confirm from './Confirmation';
import StopLimitTrigger from './StopLimitTrigger';

import withI18n from '../utils/withI18n';
import zIndexScale from '../utils/zIndexScale';
import { formatNumber } from '../utils/number';
import { replace as i18nReplace, getLabel } from '../utils/i18n';
import type { RowGetter, CellRenderer } from '../utils/dataTypes';
import { fetchMaxBorrowAmount, setMarginAccountMaxBorrowable as setMarginAccountMaxBorrowableAction } from '../actions/actionsSet/margin';

const ALL = 'All';
const LIMIT_ORDER = 'Limit Order';
const STOP_LIMIT_ORDER = 'Stop-Limit Order';
const LIMIT_MAKER = 'Limit-Maker';
const ROW_HEIGHT = 30;
const HEADER_HEIGHT = 30;
const DEFAULT_WIDTH = 1260;
const PRO_DEFAULT_WIDTH = 1333;

const CANCEL_ENUMS = {
  [ALL]: 'ALL',
  [LIMIT_ORDER]: 'LIMIT',
  [STOP_LIMIT_ORDER]: 'STOP_LIMIT',
  [LIMIT_MAKER]: 'LIMIT_MAKER',
};

const CANCEL_ENUMS_I18N = {
  [ALL]: 'exchange-cancelEnums-all',
  [LIMIT_ORDER]: 'exchange-cancelEnums-limitOrder',
  [STOP_LIMIT_ORDER]: 'exchange-cancelEnums-stopLimitOrder',
  [LIMIT_MAKER]: 'exchange-cancelEnums-limitMaker',
};

const CANCEL_KEYS = Object.keys(CANCEL_ENUMS);

const Label = styled.span`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const GreenLabel = styled(Label)`
  color: ${({ theme }) => theme.up};
`;
const RedLabel = styled(Label)`
  color: ${({ theme }) => theme.down};
`;

const Container = styled(FlexBox)`
  flex: 1 0 100%;
  min-height: ${({ isLoggedIn, pro }) => {
    if (pro) return '100%';
    return isLoggedIn ? '250px' : '29px';
  }};
  position: relative;
  .ReactVirtualized__Table__headerColumn{
    span{
      line-height: 20px;
    }
  },
  .ReactVirtualized__Table__rowColumn {
    margin-right: 7px;
  }
  .ReactVirtualized__Table__headerColumn:first-of-type,
  .ReactVirtualized__Table__rowColumn:first-of-type {
    margin-left: 7px;
  }
`;

const ToggleInput = styled.input`
  margin-right: .5em;
  vertical-align:middle;
`;

const Panel = styled(FlexBox)`
  position: absolute;
  right: 0;
  /* bad */
  top: -30px;
`;

const ToggleLabel = styled.label`
  margin-right: 1em;
`;

const CTA = styled.button`
  background: ${({ theme }) => theme.buttonbg};
  border: 1px solid ${({ theme }) => theme.border};
  cursor: pointer;
  outline: none;
  color: ${({ theme }) => theme.fontColor};
  &:hover {
    background-color: ${({ theme }) => theme.chartbuttonbg};
    color: ${({ theme }) => theme.highlight};
  }
`;

const CancelHeader = styled(FlexBox)`
  position: absolute;
  top: .3em;
`;

const DropdownCTA = styled(CTA)`
  outline: none;
  padding: .1em .5em;
  width: 100%;
`;

const CancelAll = styled(CTA)`
  padding: .05em .5em;
  :hover {
    background: ${({ theme }) => theme.buttonbg};
  }
`;

const Cancel = styled(CTA)`
  padding: .05em .5em;
`;

const CancelMenuItem = styled.li`
  display: flex;
  height: 25px;
  flex: 1 0 100%;
  font-size: 13px;
  color: #333;
  &:not(:first-child) button {
    border-top: none;
  }
`;

const DropdownIcon = styled.span`
  position:relative;
  margin: 0;
  height: 20px;
  width: 20px;
  line-height: 1.3;
  width: 20px;
  text-align: center;
  cursor: pointer;
  color: ${({ theme }) => theme.fontColor};
  background: ${({ theme }) => theme.buttonbg};
  border: 1px solid ${({ theme }) => theme.border};
   & :after {
    content: " ";
    border: 5px solid transparent;
    border-top-color: #d4d4d4;
    position: absolute;
    left: -50;
    left: 50%;
    top: 66%;
    transform: translate(-50%,-50%);
  }
      }
`;

const CancelList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  right: 0;
  top: 1.6em;
  z-index: ${zIndexScale.dropdown};
  white-space: nowrap;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.bg};
  box-shadow: ${({ theme }) => theme.boxShadow};
  min-width: 120px;
`;

const alignRight = { 'justifyContent': 'flex-end', 'paddingRight': '1em' };
const alignCenter = { 'justifyContent': 'center' };

const HeaderRowRenderer = styled(FlexBox)`
  border-bottom: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.fontColor3};
  font-weight: normal;
  line-height: 1;
  width: 100%;
`;

const RowRenderer = styled(FlexBox)`
  border-bottom: 1px solid ${({ theme }) => theme.border};
  cursor: pointer;
`;

type sharedPropTypes = {
  i18n: Object,
  hide: boolean,
  onMouseLeave: Function,
  handleMenuClick: Function,
};

const CancelMenu = (props: sharedPropTypes) => (
  <Dropdown
    component={CancelList}
    keys={CANCEL_KEYS}
    isOpen={!props.hide}
    onMouseLeave={props.onMouseLeave}
    {...props}
  >
    {({ key: _cancelMethod }) => (
      <CancelMenuItem key={_cancelMethod}>
        <DropdownCTA
          onClick={() => props.handleMenuClick(_cancelMethod)}
        >
          {getLabel(CANCEL_ENUMS_I18N[_cancelMethod], props.i18n)}
        </DropdownCTA>
      </CancelMenuItem>
    )}
  </Dropdown>
);

CancelMenu.defaultProps = {};

type LoggedInUserPanelPropTypes = {
  message: string,
  i18n: Object,
}

const LoggedInUserPanel = ({ i18n, message, ...props }: LoggedInUserPanelPropTypes) => (
  <Panel>
    <ToggleLabel htmlFor="toggle-open-orders">
      <ToggleInput id="toggle-open-orders" type="checkbox" {...props} />
      {message || getLabel('exchange-OpenOrdersTable-noOpenOrders', i18n)}
    </ToggleLabel>
  </Panel>
);

LoggedInUserPanel.defaultProps = {};

const mapStateToProps = ({
  isLoggedIn,
  tickSizes,
  minTrades,
  locale,
  marginStatus,
  marginBorrow_BUY,
  marginBorrow_SELL,
}, { pair }) => ({
  isLoggedIn,
  tickSizes,
  minTrades,
  locale,
  marginStatus,
  marginBorrow_BUY,
  marginBorrow_SELL,
  pair,
});
const mapDispatchToProps = ({
  deleteOrder: deleteOrderAction,
  setMarginAccountMaxBorrowable: setMarginAccountMaxBorrowableAction,
});

type Props = {
  symbol: string,
  i18n: Object,
  isLoggedIn: boolean,
  deleteOrder?: Function,
  tickSizes: Object,
  minTrades: Object,
  base: string,
  pro: boolean,
  locale: string,
  theme: Object,
  openOrders: Array<Object>,
  isMargin?: boolean,
  marginStatus: boolean,
  marginBorrow_BUY: boolean,
  marginBorrow_SELL: boolean,
  both: Array<any>,
  setMarginAccountMaxBorrowable: Function,
}

type States = {
  hideOtherPairs: boolean,
  cancelMenuPopped: boolean,
}

type TableProps = { columns?: React.Node }

export default
@withI18n
@withTheme
@connect(mapStateToProps, mapDispatchToProps)
class OpenOrdersTable extends React.Component<Props, States> {
  static defaultProps = {
    i18n: {},
    isLoggedIn: false,
    deleteOrder: () => {},
    openOrders: [],
    tickSizes: {},
    minTrades: {},
    pro: false,
    locale: 'en',
    theme: {},
    both: [],
    marginStatus: false,
    marginBorrow_BUY: false,
    marginBorrow_SELL: false,
    setMarginAccountMaxBorrowable: () => {},
  }

  state = {
    hideOtherPairs: false,
    cancelMenuPopped: false,
  }

  componentDidMount() {
    /* eslint-disable */
    this.setState({ hideOtherPairs: JSON.parse(sessionStorage.getItem('openOrderHideOtherPairs') || 'false') });
  }

  setMaxBorrowable = ()=>{
    const {marginStatus,marginBorrow_BUY,marginBorrow_SELL,both:[base,quote],setMarginAccountMaxBorrowable} =this.props
    if (marginStatus) {
      if (marginBorrow_BUY) {
        fetchMaxBorrowAmount(quote).then(asset => setMarginAccountMaxBorrowable({ [quote]: asset }));
      }
      if (marginBorrow_SELL) {
        fetchMaxBorrowAmount(base).then(asset => setMarginAccountMaxBorrowable({ [base]: asset }));
      }
    }
  }

  _rowGetter = ({ index }: RowGetter) =>this._getOpenOrders()[index];

  _headerRowRenderer =(props: TableProps) =>
    <HeaderRowRenderer {...props}>{props.columns}</HeaderRowRenderer>

  _rowRenderer = (props: TableProps) => <RowRenderer {...props}>{props.columns}</RowRenderer>

  _noRowsRenderer = (props: Props) => {
    const { hideOtherPairs } = this.state;
    const {
      i18n, symbol, base, pro,
    } = this.props;
    const message = hideOtherPairs ?
      i18nReplace([`${base}/${(symbol||'').replace(base, '')}`], getLabel('exchange-trade-noCurrentSymbolOpenOrders', i18n))
      : getLabel('exchange-OpenOrdersTable-noOpenOrders', i18n);
    return <EmptyResult {...props} message={message} pro={pro} />;
  }

  _cancelOpenOrders = (type: string) => {
    const allOrders = this._getOpenOrders();
    const hasOrder = allOrders.filter(el =>
      this._isCancelTypeMatchType(type, el)
    );
    if (hasOrder.length) {
      this._showConfirm(type);
    }
    // todo has no order
  }

  _isCancelTypeMatchType(cancelType: string, el: Object) {
    const {type,orderListId}=el
    if (cancelType === LIMIT_ORDER) {
      return type === 'LIMIT';
    } else if (cancelType === STOP_LIMIT_ORDER) {
      return type === 'TAKE_PROFIT_LIMIT' || type === 'STOP_LOSS_LIMIT';
    }else if(cancelType===LIMIT_MAKER){
      return orderListId >0 // type oco
    }
    return true;
  }

  _onCancelOpenOrdersConfirm(type: string) {
    const {
      deleteOrder, symbol,isMargin
    } = this.props;
    if (!deleteOrder) return;
    const { hideOtherPairs } = this.state;
    let params = { type: CANCEL_ENUMS[type], symbol: '' };
    if (hideOtherPairs) {
      params.symbol = symbol;
    } else {
      delete params.symbol;
    }
    if(isMargin===undefined){
      deleteOrder(params)
      }
    else {
      const allOrders = this._getOpenOrders()
      if(isMargin && allOrders.length){
        const orders = allOrders.filter(el => this._isCancelTypeMatchType(type, el));
        const symbols = orders.map(el => el.symbol)
        if(orders.length) params= {...params,symbol:symbols,orderId: orders.map(e=>e.orderId)}
      }
      deleteOrder(params,isMargin).then(()=>{this.setMaxBorrowable()})
    }
  }

  _cancelOpenOrder(orderId: number) {
    const {
      deleteOrder,
      openOrders,
      isMargin
    } = this.props;
    if (!deleteOrder) return;
    const order = openOrders.find(
      (o) => o.orderId === orderId
    );
    if (order) {
      // pro page
      if(isMargin===undefined){
        deleteOrder({
          orderId,
          symbol: order.symbol,
        },undefined
          );
      }else {
        deleteOrder({
          orderId,
          symbol: order.symbol,
        },isMargin
          ).then(()=>this.setMaxBorrowable());
      }
    }
  }

  // TODO: CSSTransition
  _cancelHeaderRenderer = () => (
    <CancelHeader direction="row" wrap="nowrap">
      <CancelAll onClick={() => this._cancelOpenOrders(ALL)}>
        {/* {this.props.i18n.fullCancle || 'Cancel All'} */}
        {getLabel('exchange-OpenOrdersTable-fullCancle', this.props.i18n)}
      </CancelAll>
      <DropdownIcon
        className="iconfont icon-downsjsmall"
        onFocus={() => this._popUpCancelMenu(true)}
        onMouseEnter={() => this._popUpCancelMenu(true)}
      />
      <CancelMenu
        i18n={this.props.i18n}
        hide={!this.state.cancelMenuPopped}
        onMouseLeave={this._popUpCancelMenu}
        handleMenuClick={this._cancelOpenOrders}
      />
    </CancelHeader>
  );

  _cellRendererTrigger = ({ cellData }: CellRenderer) => {
    const { tickSizes } = this.props;
    return StopLimitTrigger({ tickSizes, cellData });
  }

  _onCheckboxClick = () => {
    sessionStorage.setItem('openOrderHideOtherPairs', JSON.stringify(!this.state.hideOtherPairs));
    this.setState({ hideOtherPairs: !this.state.hideOtherPairs });
  }

  _onConfirmCancelOpenOrderModal = (type: string) => {
    if (type && type.length > 0) {
      this._onCancelOpenOrdersConfirm(type);
    }
  }

  _getOpenOrders = () => this.props.openOrders.filter((item) => {
    if (this.state.hideOtherPairs) return item.symbol === this.props.symbol;
    return true;
  });

  _popUpCancelMenu = (bool: boolean = false) => {
    this.setState({ cancelMenuPopped: !!bool });
  };

  _getCancelOpenOrderModalContentKey(cancelType: string) {
    const { i18n } = this.props;
    switch (cancelType) {
      case ALL:
        return getLabel('exchange-OpenOrdersTable-CancelAll', i18n);
      case LIMIT_ORDER:
        return getLabel('exchange-OpenOrdersTable-CancelLimitOrder', i18n);
      case LIMIT_MAKER:
        return getLabel('exchange-OpenOrdersTable-CancelLimitMaker', i18n);
      case STOP_LIMIT_ORDER:
      default:
        return getLabel('exchange-OpenOrdersTable-CancelStopLoss', i18n);
    }
  }

  _showConfirm(cancelType: string) {
    const { i18n } = this.props;
    const key = this._getCancelOpenOrderModalContentKey(cancelType);
    const content = i18n[key] || key;
    confirm({
      area: ['280px'],
      i18n,
      content,
      theme: this.props.theme,
      onConfirm: () => this._onConfirmCancelOpenOrderModal(cancelType),
    });
  }

  render() {
    const {
      i18n,
      isLoggedIn,
      pro,
      tickSizes,
      minTrades,
      locale,
    } = this.props;
    return (
      <Container bg="theme" isLoggedIn={isLoggedIn} pro={pro}>
        <SelfOtherPairsToggler
          id="open-toggler"
          i18n={i18n}
          pro={pro}
          readMore={false}
          marginStatus={false}
          onClick={this._onCheckboxClick}
          checked={this.state.hideOtherPairs}
          textKey={''}
          locale={locale}
        />
        <ScrollableTable
          defaultWidth={pro ? PRO_DEFAULT_WIDTH : DEFAULT_WIDTH}
          defaultHeight={isLoggedIn ? undefined : 0}
          headerHeight={HEADER_HEIGHT}
          rowHeight={ROW_HEIGHT}
          rowCount={this._getOpenOrders().length}
          rowGetter={this._rowGetter}
          rowRenderer={this._rowRenderer}
          noRowsRenderer={this._noRowsRenderer}
          nonce={typeof window !== 'undefined' && window.__NONCE__}
          scrollable={isLoggedIn}
          contentOverflowVisible={!isLoggedIn && !pro}
        >
          <ScrollableTable.Column
            label={getLabel('exchange-OpenOrdersTable-Date', i18n)}
            dataKey="transactTime"
            width={138}
            cellDataGetter={({ rowData }) => rowData && (rowData.time)}
            cellRenderer={({ cellData }) => <Moment element="span" format="MM-DD HH:mm:ss">{cellData}</Moment>}
          />
          <ScrollableTable.Column
            label={getLabel('exchange-OpenOrdersTable-Pair', i18n)}
            dataKey="symbol"
            width={105}
            cellDataGetter={({ rowData }) => rowData && `${rowData.baseAsset}/${rowData.quoteAsset}`}
          />
          <ScrollableTable.Column
            label={getLabel('exchange-OpenOrdersTable-Type', i18n)}
            dataKey="type"
            width={111}
            cellDataGetter={({ rowData }) => rowData && rowData.orderType}
          />
          <ScrollableTable.Column
            label={getLabel('exchange-OpenOrdersTable-Side', i18n)}
            dataKey="side"
            width={88}
            cellDataGetter={({ rowData }) => rowData && rowData.side}
            cellRenderer={({ cellData }) => (
              cellData === 'BUY' ? <GreenLabel>{getLabel('exchange-OpenOrdersTable-sideBuy', i18n, 'Buy')}</GreenLabel> :
              <RedLabel>{getLabel('exchange-OpenOrdersTable-sideSell', i18n, 'Sell')}</RedLabel>
            )}
            headerStyle={alignCenter}
            style={alignCenter}
          />
          <ScrollableTable.Column
            label={getLabel('exchange-OpenOrdersTable-price', i18n)}
            dataKey="price"
            width={118}
            cellDataGetter={({ rowData }) =>
              rowData && formatNumber(
                rowData.price,
                tickSizes[rowData.symbol]
              )}
          />
          <ScrollableTable.Column
            label={getLabel('exchange-common-amount', i18n)}
            dataKey="origQty"
            width={106}
            cellDataGetter={({ rowData }) =>
              rowData && formatNumber(
                rowData.origQty,
                minTrades[rowData.symbol]
              )}
          />
          <ScrollableTable.Column
            label={getLabel('exchange-OpenOrdersTable-filled', i18n)}
            dataKey="executedQty"
            width={94}
            cellDataGetter={({ rowData }) => rowData}
            cellRenderer={({ cellData }) =>
              `${formatNumber((parseFloat(cellData.executedQty) / parseFloat(cellData.origQty)) * 100, 2)}%`}
            headerStyle={alignRight}
            style={alignRight}
          />
          <ScrollableTable.Column
            label={getLabel('exchange-OpenOrdersTable-total', i18n)}
            dataKey="total"
            width={212}
            cellDataGetter={({ rowData }) => rowData}
            cellRenderer={({ cellData }) =>
              `${formatNumber(parseFloat(cellData.origQty) * parseFloat(cellData.price), tickSizes[cellData.symbol])} ${cellData.quoteAsset}`}
            headerStyle={alignRight}
            style={alignRight}
          />
          <ScrollableTable.Column
            label={getLabel('exchange-OpenOrdersTable-TriggerConditions', i18n)}
            dataKey="condition"
            width={120}
            cellDataGetter={({ rowData }) => rowData}
            cellRenderer={this._cellRendererTrigger}
          />
          <ScrollableTable.Column
            headerRenderer={this._cancelHeaderRenderer}
            dataKey="cancel"
            width={pro ? 150 : 122}
            cellDataGetter={({ rowData }) => rowData && rowData.orderId}
            cellRenderer={({ cellData }) => (
              <Cancel
                onClick={debounce(() => {
                  this._cancelOpenOrder(cellData);
                }, 2000, { 'leading': true, 'trailing': false })}
              >
                {getLabel('exchange-OpenOrdersTable-Cancel', i18n)}
              </Cancel>)}
            style={alignCenter}
            headerStyle={alignCenter}
          />
        </ScrollableTable>
      </Container>
    );
  }
}
